import { CurrencyPipe } from '@angular/common';
import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';

import { NumberUtil } from '../utils/number.util';


@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[currency-input]',
	providers: [CurrencyPipe]
})
export class CurrencyInputDirective implements OnInit {
	private el: HTMLInputElement;

	@Input() private currencyCode: string = 'USD';
	@Input() private symbolDisplay: boolean = true;
	@Input() private digitDisplay: string = '.2';
	@Input() private debounce: number = 500;
	@Input() private keyRestrictionPattern: '.';


	constructor(private elementRef: ElementRef, private currencyPipe: CurrencyPipe) {
		this.el = this.elementRef.nativeElement;
	}

	public ngOnInit(): void {
		setTimeout(() => this.updateValue(this.el.value), this.debounce);
	}

	@HostListener('focus', ['$event.target.value'])
	public onFocus(value: string): void {
		if (value) {
			const number = NumberUtil.getNumberFromString(value);
			this.el.value = number.toString();
		}
	}

	@HostListener('blur', ['$event.target.value'])
	public onBlur(value): void {
		this.updateValue(value);
	}

	@HostListener('keypress', ['$event'])
	public onKeyPress(event): boolean {
		return new RegExp(this.keyRestrictionPattern).test(event.key);
	}

	private updateValue(value): void {
		const number = NumberUtil.getNumberFromString(value);
		if (number) {
			let transformedNumber = this.currencyPipe.transform(number, this.currencyCode, this.symbolDisplay, this.digitDisplay);
			if (!this.symbolDisplay) {
				transformedNumber = transformedNumber.replace(this.currencyCode, '');
			}
			this.el.value = transformedNumber;
		}
	}
}
